"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuestionServiceImpl = void 0;
var QuestionProviderImpl_1 = require("./provider/firebase/QuestionProviderImpl");
var QuestionProviderImpl_2 = require("./provider/airabbi/QuestionProviderImpl");
var QuestionServiceImpl = (function () {
    function QuestionServiceImpl(cfg) {
        this.cfg = cfg;
        switch (cfg.provider) {
            case 'firebase':
                this.provider = new QuestionProviderImpl_1.QuestionProviderImpl(cfg);
                break;
            case 'airabbi':
                this.provider = new QuestionProviderImpl_2.QuestionProviderImpl(cfg);
                break;
        }
    }
    QuestionServiceImpl.prototype.init = function (env, cfg) {
        this.env = env;
        if (cfg) {
            this.cfg = cfg;
        }
        return this.provider.init(env);
    };
    QuestionServiceImpl.prototype.setDebuggable = function (debuggable) {
        if (this.cfg) {
            this.cfg.debuggable = debuggable;
        }
        this.provider.setDebuggable(debuggable);
    };
    QuestionServiceImpl.prototype.createComment = function (courseId, lessonId, exerciseId, studentId, questionId, commentType, content, resUrl, teachers, question, ccMailList) {
        return this.provider.createComment(courseId, lessonId, exerciseId, studentId, questionId, commentType, content, resUrl, teachers, question, ccMailList);
    };
    QuestionServiceImpl.prototype.getComments = function (courseId, studentId, questionId) {
        return this.provider.getComments(courseId, studentId, questionId);
    };
    QuestionServiceImpl.prototype.updateComment = function (courseId, studentId, questionId, comment) {
        return this.provider.updateComment(courseId, studentId, questionId, comment);
    };
    QuestionServiceImpl.prototype.updateCommentAsRead = function (courseId, reporterId, questionId, commentId) {
        return this.provider.updateCommentAsRead(courseId, reporterId, questionId, commentId);
    };
    QuestionServiceImpl.prototype.createQuestion = function (courseInfo, reporter, title, content, resUrl, ccMailList) {
        return this.provider.createQuestion(courseInfo, reporter, title, content, resUrl, ccMailList);
    };
    QuestionServiceImpl.prototype.getCourseQuestions = function (courseId) {
        return this.provider.getCourseQuestions(courseId);
    };
    QuestionServiceImpl.prototype.getStudentQuestions = function (courseId, studentId) {
        return this.provider.getStudentQuestions(courseId, studentId);
    };
    QuestionServiceImpl.prototype.getAllQuestions = function () {
        return this.provider.getAllQuestions();
    };
    QuestionServiceImpl.prototype.getQuestionsByPagination = function (skip, limit, searchType, sort, courseId, searchString) {
        return this.provider.getQuestionsByPagination(skip, limit, searchType, sort, courseId, searchString);
    };
    QuestionServiceImpl.prototype.removeComment = function (courseId, studentId, questionId, commentId) {
        return this.provider.removeComment(courseId, studentId, questionId, commentId);
    };
    QuestionServiceImpl.prototype.removeQuestion = function (courseId, creator, questionId) {
        return this.provider.removeQuestion(courseId, creator, questionId);
    };
    QuestionServiceImpl.prototype.updateLikes = function (questionId) {
        return this.provider.updateLikes(questionId);
    };
    QuestionServiceImpl.prototype.updateQuestion = function (question) {
        return this.provider.updateQuestion(question);
    };
    QuestionServiceImpl.prototype.updateReadByStudent = function (courseId, creator, questionId, read) {
        return this.provider.updateReadByStudent(courseId, creator, questionId, read);
    };
    QuestionServiceImpl.prototype.updateReadByTeacher = function (courseId, creator, questionId, read) {
        return this.provider.updateReadByTeacher(courseId, creator, questionId, read);
    };
    QuestionServiceImpl.prototype.updateResolved = function (courseId, creator, questionId, resolved) {
        return this.provider.updateResolved(courseId, creator, questionId, resolved);
    };
    QuestionServiceImpl.prototype.updateViews = function (questionId) {
        return this.provider.updateViews(questionId);
    };
    QuestionServiceImpl.prototype.startListenConversation = function (courseId, studentId, questionId, listener) {
        return this.provider.startListenConversation(courseId, studentId, questionId, listener);
    };
    QuestionServiceImpl.prototype.updateQuestionUnreadCount = function (courseId, creator, questionId) {
        return this.provider.updateQuestionUnreadCount(courseId, creator, questionId);
    };
    QuestionServiceImpl.prototype.stopListenConversation = function (courseId, studentId, questionId) {
        return this.provider.stopListenConversation(courseId, studentId, questionId);
    };
    QuestionServiceImpl.prototype.stopAllMonitor = function () {
        return this.provider.stopAllMonitor();
    };
    return QuestionServiceImpl;
}());
exports.QuestionServiceImpl = QuestionServiceImpl;
//# sourceMappingURL=QuestionServiceImpl.js.map